import React, { useState, useEffect } from 'react';
import NAVBAR from '../../Components/Navbar/NewNavbar';
import Footer from '../../Components/Footer/Footer';
import Loading1 from '../../Components/Loading/Loading1';
import { HiOutlineRefresh, HiOutlineExclamationCircle, HiOutlinePhone } from 'react-icons/hi';

function RefundPolicy() {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 800);
        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return <Loading1 />;
    }

    return (
        <div className="bg-white min-h-screen">
            <NAVBAR />
            
            <section className="pt-40 pb-20 bg-secondary relative overflow-hidden text-center">
                <div className="container-custom relative z-10 mx-auto max-w-2xl">
                    <span className="text-primary font-black uppercase tracking-[0.3em] text-xs">Financial Statements</span>
                    <h1 className="text-5xl md:text-6xl font-heading font-black text-foreground mt-4">
                        Refund <span className="text-primary italic">Policy</span>
                    </h1>
                </div>
            </section>

            <section className="py-24">
                <div className="container-custom">
                    <div className="max-w-3xl mx-auto space-y-12">
                        <article className="card-premium p-10 md:p-16 space-y-10 border-t-8 border-t-primary">
                            <div className="space-y-4">
                                <h2 className="text-2xl font-black flex items-center gap-3">
                                    <HiOutlineExclamationCircle className="text-primary" />
                                    Investment Policy
                                </h2>
                                <p className="text-foreground/70 leading-relaxed font-medium capitalize-first">
                                    Welcome to <strong>ASTRACLEAN TECHNOLOGIES PVT LTD.</strong> To maintain our premium service quality and immediate resource allocation, we operate on a strictly transparent billing framework.
                                </p>
                            </div>

                            <div className="p-8 rounded-[2rem] bg-secondary/50 border border-border space-y-4">
                                <h3 className="text-lg font-black uppercase tracking-widest text-primary">No Refunds</h3>
                                <p className="text-sm font-semibold text-foreground/80 leading-relaxed">
                                    We regret to inform you that we do not offer refunds for any of our services. Once a booking is confirmed and payment is processed, the amount is <span className="text-primary font-black">non-refundable</span>. This ensures our dedicated professionals are always compensated for their scheduled availability.
                                </p>
                            </div>

                            <div className="space-y-6">
                                <h3 className="text-2xl font-black">Support & Resolution</h3>
                                <p className="text-foreground/70 leading-relaxed">
                                    If you have any questions regarding our financial policies or need assistance with a specific transaction, please reach out to our dedicated support concierge. We are here to ensure your satisfaction.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-4">
                                    <button className="btn-primary flex items-center justify-center gap-3 !px-10">
                                        <HiOutlinePhone size={20} />
                                        Contact Billing
                                    </button>
                                </div>
                            </div>

                            <p className="text-xs font-black uppercase tracking-widest text-muted-foreground pt-10 border-t border-border">
                                Thank you for choosing AstraClean. We value your absolute trust.
                            </p>
                        </article>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default RefundPolicy;

